import { Link } from 'react-router-dom';
import { Pill } from '../../../layout/Pill.jsx';
import { Icon } from '../../../layout/Icon.jsx';

function normalize(data) {
  const arr = Array.isArray(data) ? data : data?.data || data?.items || [];
  return arr.map((p, i) => ({
    id: p.productId ?? p.id ?? p._id ?? `ls-${i}`,
    name: p.name ?? p.productName ?? '—',
    // الخادم يعيد current/minStock — قراءة stock/threshold فقط كانت
    // تعرض «متبقي 0» لكل منتج.
    stock: Number(p.current ?? p.stock ?? p.quantity ?? p.qty ?? 0),
    threshold: Number(p.minStock ?? p.threshold ?? 0),
    warehouse: p.warehouse ?? p.warehouseName ?? '—'
  }));
}

export function LowStockPanel({ data }) {
  const rows = normalize(data);

  if (!rows.length) {
    return (
      <div className="text-ink-3 text-center py-10 text-sm flex flex-col items-center gap-2">
        <Icon name="check" size={32} color="#22C55E" />
        المخزون مستقر — لا تنبيهات
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {rows.map((r) => (
        <div
          key={r.id}
          className="flex items-center gap-3 p-2.5 rounded-[10px] border border-line bg-white"
        >
          <div className="w-9 h-9 rounded-[10px] bg-[#FEF3C7] text-[#92400E] grid place-items-center">
            <Icon name="inventory" size={16} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold truncate">{r.name}</div>
            <div className="text-[11px] text-ink-3">{r.warehouse}</div>
          </div>
          <Pill variant="warning">
            متبقي {r.stock}
            {r.threshold ? ` / ${r.threshold}` : ''}
          </Pill>
          <Link
            to="/products"
            className="btn"
            style={{ padding: '4px 10px', fontSize: 12 }}
          >
            تزويد
          </Link>
        </div>
      ))}
    </div>
  );
}
